import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, Modal, Typography, message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { mortageType } from "../../constants/DataConstants";
import { routes } from "../../routes/Routes";

const { Option } = Select;
const { confirm } = Modal;
const { Title, Text } = Typography;


const BusinessAssets = () => {
    const [form] = Form.useForm();
    const [assets, setAssets] = useState([
        { businessValue: "", equityStake: "", valuation: "" },
    ]);
    const history = useHistory();

    const addAsset = () => {
        setAssets([...assets, { businessValue: "", equityStake: "", valuation: "" }]);
    };

    const deleteAsset = (index) => {
        confirm({
            title: "Are you sure you want to delete this business asset?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk() {
                setAssets(assets.filter((_, idx) => idx !== index));
            },
        });
    };

    const onBack = () => {
        history.push(routes.realestateassets.path); // Update this if needed
    };

    const onNext = () => {
        history.push(routes.partnershipInterests.path); // Update this if needed
    };

    const onFinish = (values) => {
        message.success("Business Assets Saved!");
        console.log("Saved values:", values);
        onNext();
    };

    return (
        <LeftLayout>
            <Row style={{ minHeight: "100vh", background: "#fff", }} align="top" className="w450">
                <Col span={24}>
                    <Title level={3} style={{ marginTop: 40 }}>
                        Business Assets
                    </Title>
                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        {assets.map((asset, idx) => (
                            <div key={idx}>
                                <Row justify="space-between" align="middle" style={{ marginTop: 30 }}>
                                    <Col>
                                        <Text strong style={{ fontSize: 16 }}>
                                            Business {String(idx + 1).padStart(2, "0")}
                                        </Text>
                                    </Col>
                                    <Col>
                                        {idx > 0 && (
                                            <Button
                                                type="text"
                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                onClick={() => deleteAsset(idx)}
                                            />
                                        )}
                                    </Col>
                                </Row>

                                <Form.Item
                                    label="Business Value"
                                    name={["assets", idx, "businessValue"]}
                                    rules={[{ required: true, message: "Business Value is required" }]}
                                    style={{ marginTop: 16 }}
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Equity Stake Ownership"
                                    name={["assets", idx, "equityStake"]}
                                    rules={[{ required: true, message: "Equity Stake is required" }]}
                                >
                                    <Input placeholder="%" />
                                </Form.Item>

                                <Form.Item
                                    label="Valuation"
                                    name={["assets", idx, "valuation"]}
                                    rules={[{ required: true, message: "Valuation is required" }]}
                                >
                                    <Input placeholder="$" />
                                </Form.Item>
                            </div>
                        ))}

                        <Form.Item>
                            <Button
                                type="link"
                                icon={<PlusCircleOutlined />}
                                onClick={addAsset}
                                style={{
                                    padding: 0,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    marginTop: 10,
                                }}
                            >
                                Add Another Business Asset
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                                <Button
                                    type="default"
                                    onClick={onNext}
                                >
                                    Next <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout>
    );
};

export default BusinessAssets;

